exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nvideo {\n    width: 100%;\n    height: auto;\n}\n.dropleft {\n    position: absolute;\n    right: 20px;\n}\n.dropdown-toggle::before {\n    content: none !important;\n}\n.search-form {\n    width: 100%;\n    float: right;\n    position: relative;\n}\n.fa-search {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n", ""]);

// exports
